
<div class="modal-content">
  <div class="modal-header">
    <label class="modal-title text-text-bold-900" id="myModalLabel33"><b>Kurs Ekle/Güncelle</b></label>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <form [formGroup]="definitionForm">
    <div class="modal-body">
  

      <div class="form-group">
        <label>Ana Dili</label>
        <select class="form-control" formControlName="toId">
          <option *ngFor="let l of languages" [value]="l.id">{{l.name}}</option>
        </select>
      </div>
      <div class="form-group">
        <label>Öğrenilecek Dil</label>
        <select class="form-control" formControlName="fromId">
          <option *ngFor="let l of languages" [value]="l.id">{{l.name}}</option>
        </select>
      </div>
 
   

     

    </div>

  


    <div class="modal-footer">
      <button type="reset" class="btn grey btn-outline-secondary btn-lg"
        (click)="close()">Kapat</button>
      <button type="button" class="btn btn-primary btn-lg" (click)="save()" [disabled]="submitted">
        <i class="fa fa-refresh fa-spin" *ngIf="submitted"></i>
        Kaydet</button>
    </div>
  </form>
</div>

